var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"tabindex":"0"},on:{"focus":function($event){return _vm.focusLastDescendant(_vm.$refs.privacyCenter.$el)}}}),_c('privacy-center',{ref:"privacyCenter",attrs:{"data":_vm.configuration}}),_c('div',{attrs:{"tabindex":"0"},on:{"focus":function($event){return _vm.focusFirstDescendant(_vm.$refs.privacyCenter.$el)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }